<template>
  <el-card shadow="never" class="aui-card--fill">
    <div>
      <h2 class="title">企业管理员账号资料</h2>
      <el-form :model="dataForm2" ref="dataForm" label-width="220px" justify="center">
         <h3>用户基本资料</h3>
        <el-row>
          <el-col :span="10">
            <el-form-item prop="username" label="登录账号：">
              <span>{{dataForm2.username}}</span>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item prop="mobile" label="手机号：">
              <span>{{dataForm2.mobile}}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="10">
            <el-form-item prop="realName" label="姓名：">
              <span>{{dataForm2.realName}}</span>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item prop="email" label="邮箱：">
              <span>{{dataForm2.email}}</span>
            </el-form-item>
          </el-col>
        </el-row>

        <h3>个人商户基本资料</h3>
        <el-row>
          <el-col :span="10">
            <el-form-item prop="welfareMerchantName" label="商家名称：">
              <span>{{dataForm2.welfareMerchantName}}</span>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item prop="realName" label="姓名：">
              <span>{{dataForm2.realName}}</span>
            </el-form-item>
          </el-col>
        </el-row>

         <el-row>
          <el-col :span="10">
            <el-form-item prop="idCardNumber" label="身份证号：">
              <span>{{dataForm2.idCardNumber}}</span>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item prop="mobilePhone" label="手机号：">
              <span>{{dataForm2.mobilePhone}}</span>
            </el-form-item>
          </el-col>
        </el-row>

       

        
            <!-- 账户信息 -->
         <el-row>
          <el-col :span="10">
            <el-form-item label="开户人：" prop="accountName">
                 <span>{{dataForm2.accountName}}</span>
              <!-- <el-input type="type" v-model="dataForm2.accountName" autocomplete="off"></el-input> -->
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="银行账户：" prop="accountBankNumber">
                 <span>{{dataForm2.accountBankNumber}}</span>
              <!-- <el-input v-model="dataForm2.accountBankNumber" autocomplete="off"></el-input> -->
            </el-form-item>
          </el-col>
        </el-row>

        
        <el-row>
          <el-col :span="10">
            <el-form-item label="开户行：" prop="accountBankName">
                <span>{{dataForm2.accountBankName}}</span>
              <!-- <el-input type="type" v-model="dataForm2.accountBankName" autocomplete="off"></el-input> -->
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="返点值：" prop="rebate">
                  <span>{{dataForm2.rebate}}</span>
              <!-- <el-input v-model="dataForm2.rebate" autocomplete="off"></el-input> -->
            </el-form-item>
          </el-col>
        </el-row>

        
        <el-row>
          <el-col :span="10">
            <el-form-item label="付款账期：" prop="accountPeriod">
                 <span>{{dataForm2.accountPeriod}}</span>
              <!-- <el-input type="type" v-model="dataForm2.accountPeriod" autocomplete="off"></el-input> -->
            </el-form-item>
          </el-col>
        </el-row>

         <!-- <el-row>
          <el-col :span="10">
            <el-form-item label="微信账号：" prop="accountWeiXinNumber">
                  <span>{{dataForm2.accountWeiXinNumber}}</span>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="支付宝账号：" prop="accountPayBaoNumber">
                <span>{{dataForm2.accountPayBaoNumber}}</span>
            </el-form-item>
          </el-col>
        </el-row> -->
    
      </el-form>
      <div style="text-align:center">
        <el-button @click="$router.push({name:'personBusiness',query:{record:2}})">返回</el-button>
      </div>  
    </div>
  </el-card>
</template>

<script>
export default {
  data() {
    return {
        enterpriseRegionProvince:"",
        enterpriseRegionCity:"",
        enterpriseRegion:"",

      infoList:{},
      roleList2: [],
      roleList: [],
      dialogVisible: false,
      visible: false,
      type: null,
      dataForm2:{
      },
      curForm: {
        id: "",
        tanantState: "1",
        tanantRemark: "",
        roleIdList: []
      },
      src:
        "https://cube.elemecdn.com/6/94/4d3ea53c084bad6931a56d5158a48jpeg.jpeg",
      radio: 1
    };
  },
  created() {
    this.getRegistInfo(this.$route.query.id);
  },
  methods: {
    //获取银行全部信息
    async getRegistInfo(id) {
      const res1 = await this.$request.post("/approver-api/api/wemp/approvePersonAccount/info",{personAccountId: id});
      const res2 = await this.$request.post("/approver-api/api/wemp/approvetenantinformation/info",{tenantInformationId: res1.data.tenantInformationId});
    //   this.infoList={...res1.data,...res2.data} 
      this.dataForm2={...res1.data,...res2.data} 
      // this.dataForm2={...res1.data} 
      console.log(this.infoList)

    }
  }
};
</script>

<style lang="less" scoped>
h3 {
  padding-left: 30px;
}

.el-image {
  height: 50px;
  width: 80px;
  img {
    width: 100%;
  }
}

.role {
  border: 1px solid #ccc;
  text-align: center;
  border-radius: 5px;
  float: left;
  margin-left: 2px;
  font-size: 12px;
  padding-left: 5px;
  padding-right: 5px;
  box-sizing: border-box;
}

</style>
